import React from 'react';
import styles from "./Form30Header.module.css";
import stylesButtons from "../../../assets/styles/buttons.module.css";
import Select, {components, SingleValue} from "react-select";
import {DropdownIndicator} from "../../shared/DropdownIndicator";
import {customStyles, SelectOption} from "../../shared/selectStyles";
import {ImportJson} from "../ImportJSON/ImportJSON";
import {SectorSelect} from "../SectorSelect/SectorSelect";
import {Sector} from "../../../services/models/sector";
import {FormActionButton} from "../../shared/buttons/FormActionButton";
import {useNavigate} from "react-router-dom";

interface Form30HeaderProps {
    isAdmin?: boolean;
    isRoiv?: boolean;
    sectors?: Sector[];
    selectedYear: number;
    setSelectedYear: React.Dispatch<React.SetStateAction<number>>;
    onSave?: () => void;
    isSaving?: boolean;
    selectedSectorId?: string | null;
    onSectorChange?: (sectorId: string) => void;
    onImport?: (data: Record<string, Record<string, Record<string, number | null>>>) => void;
    onImportAndSave?: (data: Record<string, Record<string, Record<string, number | null>>>) => Promise<void>;
}

export const Form30Header: React.FC<Form30HeaderProps> = ({
    isAdmin,
    isRoiv,
    selectedYear,
    setSelectedYear,
    sectors = [],
    onSave,
    isSaving = false,
    selectedSectorId,
    onSectorChange,
    onImport,
    onImportAndSave,
}) => {
    // Генерируем опции для годов (от текущего года до 10 лет назад)
    const currentYear = new Date().getFullYear();
    const yearOptions: SelectOption[] = React.useMemo(() => {
        const years: SelectOption[] = [];
        const startYear = currentYear - 10;
        for (let year = currentYear; year >= startYear; year--) {
            years.push({
                value: year.toString(),
                label: year.toString(),
                fullLabel: year.toString()
            });
        }
        return years;
    }, [currentYear]);

    const selectedYearOption = yearOptions.find(opt => opt.value === selectedYear.toString()) || null;

    return (
        <div className={styles.headerWrapper}>
            <div className={styles.headerInner}>
                <div className={styles.left}>
                    <div className={styles.selectWrapper}>
                        <SectorSelect
                            sectors={sectors}
                            selected={selectedSectorId}
                            onSectorChange={onSectorChange}
                            disabled={isSaving || isRoiv}
                            isAdmin={isAdmin}
                        />
                    </div>
                    <div className={styles.selectWrapper}>
                        <Select
                            isMulti={false}
                            classNamePrefix="select"
                            name="year"
                            options={yearOptions}
                            isSearchable={false}
                            isClearable={false}
                            isDisabled={isSaving}
                            placeholder={"Выберите год"}
                            noOptionsMessage={() => "Нет доступных опций"}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator,
                                Option: components.Option
                            }}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={true}
                            blurInputOnSelect={true}
                            value={selectedYearOption as SingleValue<SelectOption>}
                            onChange={(newValue: SingleValue<SelectOption>) => {
                                if (newValue) {
                                    setSelectedYear(parseInt(newValue.value));
                                }
                            }}
                            styles={{
                                ...customStyles,
                                control: (provided, state) => ({
                                    ...(customStyles.control?.(provided, state) || provided),
                                    padding: '22px 24px',
                                }),
                            }}
                        />
                    </div>
                </div>
                <div className={styles.right}>
                    {!isAdmin && isRoiv && (
                       <>
                           <FormActionButton
                               text={"Сохранить"}
                               disabled={isSaving}
                               className={stylesButtons.mainButton}
                               onClick={onSave}
                           />
                           <ImportJson onImport={onImport} onSave={onImportAndSave} />
                       </>
                    )}
                </div>
            </div>
        </div>
    )
};
